const DEFAULT_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
};

export const formatDate = (
  dateString: number | Date,
  language: string,
  options: Intl.DateTimeFormatOptions = DEFAULT_DATE_FORMAT_OPTIONS
) => {
  return new Date(dateString).toLocaleDateString(language, options);
};
